<template>
  <router-view />
</template>

<style>
html,
body,
#app {
  height: 100%;
  margin: 0;
}

body {
  font-family: 'Segoe UI', Roboto, Helvetica, Arial, sans-serif;
  background: radial-gradient(circle at 15% 20%, #d9f7ff 0%, #eef4ff 40%, #f8fbff 100%);
  color: #0f172a;
}
</style>
